/* eslint-disable */
<template>
  <v-container id="admin-table-pagination" >
      <v-footer fixed class="d-flex align-center justify-center pagination-footer">
        <el-pagination
          v-if="adminDataLoaded && !adminAjaxing"
          id="pagination"
          :current-page.sync="queryParamsAdmin.page"
          :page-sizes="rowsPerPage"
          :page-size="queryParamsAdmin.per_page"
          layout="sizes, prev, pager, next"
          :total="total"
          :disabled="adminAjaxing"
          @size-change="sizeChange"
          @prev-click="pageChange"
          @next-click="pageChange"
          @current-change="pageChange"
          >
        </el-pagination>
      </v-footer>
  </v-container>
</template>

<script>
import router from '../../router';
import { mapState, mapGetters, mapMutations } from 'vuex';
import {
  waitForElementToDisplay
} from '@utilities';

export default {
  name: 'admin-table-pagination',
  computed: {
    ...mapState('admin', [
      'playlists',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
    ]),
    ...mapGetters('admin', [
    'activeViewAdmin',
    'queryParamsAdmin',
    'adminAjaxing',
    'adminDataLoaded',
    'schools',
    'instructors',
    'bulbs',
    'courses',
    'students'

  ]),
    total: function(){
      //total data based on active view
      switch(this.activeViewAdmin) {
        case 'Schools':
          return this.schools.pagination.total;
        case 'Instructors':
          return this.instructors.pagination.total;
        case 'Bulbs':
          return this.bulbs.pagination.total || this.playlists.pagination.total;
        case 'Treeview':
          return this.bulbs.pagination.total || this.playlists.pagination.total;
        default:
          console.log("Error: Please add total to instructor pagination switch statement")
          return 0;
      }
    },
    rowsPerPage: function(){
      //rows per page based on active view
      switch(this.activeViewAdmin) {
        case 'Schools':
          return this.schools.pagination.rowsPerPage;
        case 'Instructors':
          return this.instructors.pagination.rowsPerPage;
        case 'Bulbs':
          return this.bulbs.pagination.rowsPerPage || this.playlists.pagination.rowsPerPage;
        case 'Treeview':
          return this.bulbs.pagination.rowsPerPage;
        default:
          console.log("Error: Please add rows per page to instructor pagination switch statement")
          return 0;
      }
    },
  },
  methods:{
    ...mapMutations([
      'handleDialogOpen'
    ]),
    sizeChange: function(event){
      //record page size change and sets query params
      let queryParams = {per_page:event, page:1};
      this.$store.commit('admin/setQueryParams', queryParams);
      this.$store.dispatch('admin/getTableData');
      this.$store.dispatch('admin/updateUrl');
    },
    pageChange: function(event){
      //record page change and sets query params
      let queryParams = {page:event};

      //sets query params to state, calls for data, and updates url
      this.$store.commit('admin/setQueryParams', queryParams);
      this.$store.dispatch('admin/getTableData');
      this.$store.dispatch('admin/updateUrl');
    },
  },
  async updated() {
    const previousPageButton = await waitForElementToDisplay('.btn-prev');
    if (previousPageButton) previousPageButton[0].ariaLabel = 'Previous pagination page';
    const nextPageButton = await waitForElementToDisplay('.btn-next');
    if (nextPageButton) nextPageButton[0].ariaLabel = 'Next pagination page';
  },
};
</script>

<style scoped>
  #admin-table-pagination{
   display: flex;
   flex-flow: row;
   justify-content: center;
   align-items: center;
  }

  #pagination {
    flex: 0 1 auto !important;
  }

  .pagination-footer {
    height: 65px !important;
    margin-left: 55px;
  }

  #pagination button,
  #pagination ul,
  .pagination-footer {
    background-color: #fafafa !important;
  }

</style>


